import React from 'react';
import { styled } from '@miro-site/ui-styled-engine';
import { Section, Grid, GridItem, Box, Typography, Button, ArrowToRight, Image, IconButton } from '@miro-site/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TemplatesGridItem = styled(GridItem, {
  borderBottom: '1px solid',
  borderColor: '$gray-30',
  position: 'relative',
  '&::after': {
    content: '',
    position: 'absolute',
    width: '0%',
    height: '1px',
    bottom: '0',
    backgroundColor: '$indigo-90',
    transition: 'width 0.3s ease-in-out'
  },
  '.image-wrapper': {
    display: 'none',
    position: 'absolute',
    right: '-2px',
    top: '-15px',
    opacity: '0',
    zIndex: '-1',
    transform: 'translateY(40px) rotate(10deg)',
    transition: 'opacity 0.3s 0.3s ease-out, transform 0.3s 0.3s ease-out',
    maxWidth: '300px'
  },
  '@md': {
    '.image-wrapper': {
      display: 'block',
      zIndex: '1'
    }
  },
  '&:hover': {
    cursor: 'pointer',
    '@md': {
      '&::after': {
        width: '100%'
      },
      '.image-wrapper': {
        opacity: '1',
        transform: 'translateY(0px) rotate(0deg)'
      }
    }
  },
  '.content-wrapper': {
    marginRight: '$800'
  },
  '.icon-wrapper': {
    position: 'absolute',
    top: '0',
    right: '0',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    '@md': {
      display: 'none'
    }
  }
});
var ArrowIconButton = styled(IconButton, {
  marginLeft: '$200',
  flex: '0 0 36px',
  height: '36px',
  padding: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

var TemplatesSection = function TemplatesSection(props) {
  var _props$templates, _props$cta, _props$cta2;

  return /*#__PURE__*/_jsxs(Section, {
    pageTopInset: "1200",
    children: [/*#__PURE__*/_jsx(Grid, {
      children: /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        css: {
          borderBottom: '1px solid $gray-30'
        },
        children: /*#__PURE__*/_jsx(Typography, {
          offsetBottom: {
            '@initial': '600',
            '@lg': '800'
          },
          tag: "h2",
          type: "heading",
          variant: "heading-2",
          renderChildrenAsHTML: true,
          children: (props === null || props === void 0 ? void 0 : props.title) || ''
        })
      })
    }), props === null || props === void 0 ? void 0 : (_props$templates = props.templates) === null || _props$templates === void 0 ? void 0 : _props$templates.map(function (template, index) {
      var _template$image;

      return /*#__PURE__*/_jsx(Grid, {
        children: /*#__PURE__*/_jsxs(TemplatesGridItem, {
          xs: 12,
          children: [/*#__PURE__*/_jsx("a", {
            href: template === null || template === void 0 ? void 0 : template.templateLink,
            children: /*#__PURE__*/_jsx(Grid, {
              columns: {
                '@initial': 12,
                '@md': 11
              },
              disableGutter: true,
              css: {
                gridRowGap: '0'
              },
              asChild: true,
              children: /*#__PURE__*/_jsxs("div", {
                className: "content-wrapper",
                children: [/*#__PURE__*/_jsx(GridItem, {
                  xs: 12,
                  md: 4,
                  css: {
                    display: 'flex',
                    alignItems: 'center'
                  },
                  children: /*#__PURE__*/_jsx(Typography, {
                    offsetBottom: {
                      '@initial': '300',
                      '@md': '400'
                    },
                    offsetTop: {
                      '@initial': '300',
                      '@md': '400'
                    },
                    variant: "sub-heading-1",
                    renderChildrenAsHTML: true,
                    children: template.templateName || ''
                  })
                }), /*#__PURE__*/_jsx(GridItem, {
                  xs: 12,
                  md: 5,
                  children: /*#__PURE__*/_jsx(Typography, {
                    offsetBottom: {
                      '@initial': '300',
                      '@md': '400'
                    },
                    offsetTop: {
                      '@initial': 'none',
                      '@md': '400'
                    },
                    variant: "body-text-1",
                    renderChildrenAsHTML: true,
                    children: template.description || ''
                  })
                })]
              })
            })
          }), (template === null || template === void 0 ? void 0 : (_template$image = template.image) === null || _template$image === void 0 ? void 0 : _template$image.desktop) && /*#__PURE__*/_jsx("div", {
            className: "image-wrapper",
            children: /*#__PURE__*/_jsx(Image, {
              image: template.image.desktop
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "icon-wrapper",
            children: /*#__PURE__*/_jsx(ArrowIconButton, {
              css: {
                height: '36px'
              },
              href: template === null || template === void 0 ? void 0 : template.templateLink,
              icon: /*#__PURE__*/_jsx(ArrowToRight, {})
            })
          })]
        })
      }, 'templates-' + index);
    }), /*#__PURE__*/_jsx(Grid, {
      children: /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: /*#__PURE__*/_jsx(Box, {
          offsetTop: "800",
          children: /*#__PURE__*/_jsx(Button, {
            appearance: "outlined",
            endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
            rounded: true,
            size: "large",
            variant: "primary",
            href: props === null || props === void 0 ? void 0 : (_props$cta = props.cta) === null || _props$cta === void 0 ? void 0 : _props$cta.href,
            children: props === null || props === void 0 ? void 0 : (_props$cta2 = props.cta) === null || _props$cta2 === void 0 ? void 0 : _props$cta2.text
          })
        })
      })
    })]
  });
};

export default TemplatesSection;